import clsx from 'clsx'
import { Trans, useTranslation } from 'react-i18next'

import { Link } from 'src/components/Link/Link'
import { Price } from 'src/components/Price/Price'
import { Text } from 'src/components/Text/Text'
import { config } from 'src/config'
import { useCartQuery } from 'src/hooks/useCartQuery'

import styles from './CartLineItemDonationInfo.module.scss'

import type { MoneyV2 } from 'src/data/graphql-generated'
import type { SocialProjectIdentifier } from 'src/enum/SocialProject'

interface CartLineItemDonationInfoProps {
  donationPrice: MoneyV2
  inMinicart?: boolean
  isLastItem: boolean
}

export const CartLineItemDonationInfo = ({
  donationPrice,
  inMinicart = false,
  isLastItem,
}: CartLineItemDonationInfoProps) => {
  const { t } = useTranslation()
  const { data: cart } = useCartQuery()

  if (!donationPrice) return null

  const cartAttributeSocialProject = cart?.attributes.find((attribute) => attribute.key === 'social-project')
  const { socialProjectsKey, socialProjectDefaultIdentifier } = config
  const initialProject = cartAttributeSocialProject
    ? socialProjectsKey[cartAttributeSocialProject.value as SocialProjectIdentifier]
    : socialProjectsKey[socialProjectDefaultIdentifier as SocialProjectIdentifier]

  const projectName = t(`cart.socialProjects.${initialProject}.title`)
  const socialProjectsLinkText = t('cart.cartLine.socialProjectsLinkText')

  return (
    <div className={clsx(styles.donationWrapper, inMinicart && styles.inMinicart)}>
      <div className={clsx(styles.donationContainer, isLastItem && styles.isLastItem)}>
        <div className={styles.arrowUp} />
        <div className={styles.donationImageContainer}>
          <img src="/assets/svg/illustrations/1-euro-donation.svg" alt="spende-badge" />
        </div>

        <div className={styles.infoTextContainer}>
          <Text bold>
            <Trans
              i18nKey="cart.cartLine.donationInfo"
              values={{ projectName }}
              components={[<Price key="price" price={donationPrice} />]}
            />
          </Text>
          <Link href="#social-projects">{socialProjectsLinkText}</Link>
        </div>
      </div>
    </div>
  )
}
